"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleUtil = void 0;
const CountriesWithUsArtNr_1 = require("./CountriesWithUsArtNr");
const LocaleCurrencyService_1 = require("./LocaleCurrencyService");
const UnitSystem_1 = require("./UnitSystem");
const LocalizedArtNr_1 = require("./LocalizedArtNr");
/**
 * The `LocaleUtil` is a stateless collection of methods to support locale handling.
 */
class LocaleUtil {
    /**
     * Retrieves the artNr according to the artNrCountry or as fallback with priority DE over US.
     */
    static getArtNrWithFallback(localizedArtNr, artNrCountry) {
        if (localizedArtNr) {
            if (artNrCountry) {
                return localizedArtNr[artNrCountry];
            }
            if ('DE' in localizedArtNr) {
                return localizedArtNr['DE'];
            }
            if ('US' in localizedArtNr) {
                return localizedArtNr['US'];
            }
            else {
                // we do nothing here since we might deal with invented articles not having a regular artNr.
            }
        }
        return undefined;
    }
    /**
     * Determine the correct article number country.
     */
    static findArtNrCountry(userCountry, quoteCountry) {
        var _a;
        const country = (_a = (quoteCountry ? quoteCountry : userCountry)) !== null && _a !== void 0 ? _a : 'DE';
        return country in CountriesWithUsArtNr_1.CountriesWithUsArtNr ? 'US' : 'DE';
    }
    /**
     * Returns true if the US article numbers should be used.
     */
    static isUsArtNr(artNrCountry) {
        return artNrCountry === 'US';
    }
    /**
     * Returns true if the international article numbers should be used.
     */
    static isInternationalArtNr(artNrCountry) {
        return artNrCountry === 'DE';
    }
    /**
     * Retrieves a localized ArtNr separator.
     *
     * for US Countries(US, MX, CA): -
     * for all others: .
     */
    static getArtNrSeparator(artNrCountry) {
        return this.isUsArtNr(artNrCountry) ? '-' : '.';
    }
    /**
     * Retrieves the default ArtNr separator ".".
     */
    static getDefaultArtNrSeparator() {
        return '.';
    }
    /**
     * Retrieves a formated date string of for the montage country, which is either based in US or DE.
     */
    static getLocaleDateStringForIaMontageCountry(iaMontageCountry) {
        const iaMontageLocale = /^US$/i.test(iaMontageCountry) ? 'en-US' : 'de-DE';
        return new Date().toLocaleDateString(iaMontageLocale);
    }
    /**
     * Retrieves a language tag for the IA montage country.
     */
    static resolveLanguageTagForIaMontageCountry(languageTag, iaMontageCountry) {
        if (iaMontageCountry === 'US') {
            return 'en';
        }
        return languageTag.startsWith('de') ? 'de' : 'en';
    }
    /**
     * Retrieves a localized article text for the IA montage country.
     */
    static resolveArticleTextForIaMontageCountry(text, iaMontageCountry, articleLocalizedTextResolver) {
        if (iaMontageCountry === 'US') {
            return text['en-US'] || text['en-GB'] || articleLocalizedTextResolver.resolve(text);
        }
        return articleLocalizedTextResolver.locale.startsWith('de')
            ? articleLocalizedTextResolver.resolve(text)
            : text['en-GB'] || text['en-US'] || articleLocalizedTextResolver.resolve(text);
    }
    /**
     * Retrieves whether two artNrCountry regions differ.
     */
    static artNrCountriesDiffer(country1, country2) {
        return ((country1 in CountriesWithUsArtNr_1.CountriesWithUsArtNr && !(country2 in CountriesWithUsArtNr_1.CountriesWithUsArtNr)) ||
            (!(country1 in CountriesWithUsArtNr_1.CountriesWithUsArtNr) && country2 in CountriesWithUsArtNr_1.CountriesWithUsArtNr));
    }
    /**
     * Determines the unit system that should be used for the given country.
     */
    static findUnitSystem(userCountry, quoteCountry) {
        const artNrCountry = this.findArtNrCountry(userCountry, quoteCountry);
        return this.isUsArtNr(artNrCountry) ? UnitSystem_1.UnitSystem.imperial : UnitSystem_1.UnitSystem.metric;
    }
    /**
     * The currency depending on a given priceCountry. See ShopSession
     */
    static getCurrencyByPriceCountry(priceCountry) {
        return LocaleCurrencyService_1.LocaleCurrencyService.getLocaleCurrency(priceCountry);
    }
    /**
     * Converts a stringified `LocalizedText` to an object having at least `DE` or `US` defined.
     */
    static parseAndExtractStringifiedArtNrs(artNrStrings) {
        const parseStringifiedArtNrs = (artNrObjString) => {
            try {
                return JSON.parse(artNrObjString);
            }
            catch (e) {
                throw new Error(`${LocaleUtil.className}.parseAndExtractStringifiedArtNrs() Unable to parse json: ${artNrObjString}`);
            }
        };
        return [...artNrStrings.values()].map((artNrObjString) => {
            const localizedArtNr = parseStringifiedArtNrs(artNrObjString);
            if (!(0, LocalizedArtNr_1.isLocalizedArtNr)(localizedArtNr)) {
                throw new Error(`${LocaleUtil.className}.parseAndExtractStringifiedArtNrs() Invalid localizedArtNr: ${localizedArtNr}`);
            }
            return localizedArtNr;
        });
    }
}
exports.LocaleUtil = LocaleUtil;
LocaleUtil.className = 'LocaleUtil';
//# sourceMappingURL=LocaleUtil.js.map